<div class="info-container">
  @for (field of fields; track field) {
    <div class="info-field">
      @if (!field.isCurrency) {
        <span>{{ field.title }}</span
          >: <span class="font-weight-bold">{{ field.value() }}</span>
        }
        @if (field.isCurrency) {
          <span>{{ field.title }}</span
            >: <span class="font-weight-bold">{{ field.value() | currency }}</span>
          }
        </div>
      }
    </div>
